module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TasksUse1-a4c39b03c305071845ac21c706fb3678.jpg";